import { useCallback } from 'react';
import { useMutation } from '@apollo/client/react';
import { toastErrorMessage } from 'utils/helpers';
import { RetryHypoNoeApiRequestDocument } from 'graphql/generated/graphql';

const useRetryApiRequest = () => {
  const [retryApiRequestMutation] = useMutation(RetryHypoNoeApiRequestDocument);

  const handleRetryRequest = useCallback(
    async (requestId: string) => {
      try {
        await retryApiRequestMutation({ variables: { requestId } });
      } catch (error) {
        toastErrorMessage(error);
      }
    },
    [retryApiRequestMutation],
  );

  return handleRetryRequest;
};

export default useRetryApiRequest;
